import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { UpdateRegistryProps } from '../../features/manageRegistry/manageRegistryTypes';
import { fetchRegistryConfigNames, fetchRegistryValues, isValidJson } from '../../services/manageRegistryService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { useEffect, useState } from 'react';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
function UpdateRegistry(props: UpdateRegistryProps){
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Registry"
    const CUR_COMPONENT_COMMON="commonPortal";
    const [registryConfigNameOptions,setRegistryConfigNameOptions] = useState<string[]>([]);
    const [showErrors,setShowErrors] = useState<boolean>(false);
    const [showLoader,setShowLoader] = useState<boolean>(false);
    useEffect(() => {
        async function getAndSetRegistryConfigNameOptions(){
            try{
                if(props.registryState.registryName){
                    const registryConfigNames = await fetchRegistryConfigNames(props.registryState.registryName);
                    setRegistryConfigNameOptions(registryConfigNames);
                }
            }catch(err){
                console.log(err);
                openPopup("Error","Something went wrong whilw fetching config names");
            }
            
        }
        getAndSetRegistryConfigNameOptions();
    },[])
    function validateAllFields(){
        if(!props.registryState.registryName){
            return "Select a Registry Name";
        }
        if(!props.registryState.configName){
            return "Select a Config Name";
        }
        if(!props.registryState.values || !isValidJson(props.registryState.values)){
            return "Registry Values must be valid JSON";
        }
        return "";
    }
    async function handleRegistrySubmit(){
        try{
            setShowLoader(true);
            if(showErrors !== true) setShowErrors(true);
            const validationMessage = validateAllFields();
            if(validationMessage!==""){
                setShowLoader(false);
                openPopup("Alert",validationMessage);
                return;
            }  
            const api= `/v1/registry/data/${props.registryState.registryName}/${props.registryState.configName}`;
            const apiType="PUT";
            const requestBody=JSON.parse(props.registryState.values)
            validateWithOtp(
              async (verifiedUser, verifyResponse) => {
                  try {
                      if(verifyResponse.status===201 || verifyResponse.status===200){
                          openPopup("Success","Registry Values updated successfully");
                      }else{
                          throw new Error();
                      }
                  } catch (apiError) {
                      console.error(apiError);
                      openPopup("Error", "Something went wrong during API call");
                  }
              },["demo","prod","prod-egtm"],"admin",api,requestBody,apiType);
            }catch(err){
            console.log(err);
            openPopup("Error","Something went wrong");
        }finally{
            setShowLoader(false);
        }
    }
    return (
        <>
      <div className="manage-registry-label">
        <span>{translate(TranslationEnum.manage_registry,"Update Registry")}</span>
      </div>
      <div className="manage-registry-inputs">
        <Autocomplete
          sx={{ width: "100%" }}
          value={props.registryState.registryName}
          disableClearable
          onChange={async (event, value: string | null) => {
            try{
                if(value){
                    props.setRegistryState({ 
                        registryName: value, 
                        configName: "",
                        values: ""
                    });
                    const registryConfigNames = await fetchRegistryConfigNames(value);
                    setRegistryConfigNameOptions(registryConfigNames);
                }
            }catch(err){
                openPopup("Error","Something went wrong");
            }
            
          }}
          options={props.registryNameOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label={translate(TranslationEnum.manage_registry,"Select Registry Name")}
              error={ showErrors  && !Boolean(props.registryState.registryName) }
              helperText={ showErrors  && !Boolean(props.registryState.registryName) && "Please select a registry name"}
            />
          )}
        />
        <Autocomplete
          sx={{ width: "100%" }}
          disableClearable
          value={props.registryState.configName}
          onChange={async (event, value: string | null) => {
            if(value){
                const registryValueResponse = await fetchRegistryValues(props.registryState.registryName,value);
                const registryJsonValue = JSON.stringify(
                    registryValueResponse,
                    null,
                    2
                );
                props.setRegistryState({...props.registryState,configName:value, values: registryJsonValue});
            }

          }}
          options={registryConfigNameOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label={translate(TranslationEnum.manage_registry,"Select Name")}
              error={ showErrors  && !Boolean(props.registryState.configName) }
              helperText={ showErrors  && !Boolean(props.registryState.configName) && "Please select a name"}
            />
          )}
        />
        <TextField
          id="outlined-multiline-flexible"
          label={translate(TranslationEnum.manage_registry,"Registry Values")}
          multiline
          rows={8}
          maxRows={8}
          value={ 
            props.registryState.values
           }
          onChange={(event) => {
            props.setRegistryState({...props.registryState, values: event.target.value })
            if(showErrors) setShowErrors(false);
          }}
          error={showErrors && !isValidJson(props.registryState.values)}
          helperText={
            showErrors &&
            !isValidJson(props.registryState.values) &&
            "Please enter a valid json"
          }
        />
        <div className="manage-registry-buttons">
          <button
            className="manage-registry-update-button"
            disabled={showLoader}
            onClick={() => {
                props.openConfirmPopup("Are you sure you want to update registry values?",handleRegistrySubmit);
            }}
          >
            {showLoader? (
              <div>
                <CircularProgress size={15} color="inherit" />
                <span className="circular-progress-container ">{translate(TranslationEnum.common_portal,"UPDATE")}</span>
              </div>
            ) : (
              <>{translate(TranslationEnum.common_portal,"UPDATE")}</>
            )}
          </button>
        </div>
      </div>
    </>
    )
}
export default UpdateRegistry;